// extracted by mini-css-extract-plugin
export var authorCard = "styles-module--authorCard--e03e6";
export var bio = "styles-module--bio--633d0";
export var image = "styles-module--image--5c743";
export var linkedAuthor = "styles-module--linkedAuthor--0c973";
export var linkedinIcon = "styles-module--linkedinIcon--a03e9";